"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamToArray = streamToArray;
var readline_1 = __importDefault(require("readline"));
function streamToArray(stream) {
    return new Promise(function (resolve, reject) {
        var lines = readline_1.default.createInterface(stream);
        var elements = [];
        lines.on('line', function (line) { return elements.push(JSON.parse(line)); });
        lines.on('close', function () { return resolve(elements); });
        lines.on('error', reject);
    });
}
